import { Drawer } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { MODAL_SIZES } from 'config/modaSettings';
import { FormListPageStore } from 'stores/local';

import { NotificationDrawerContent } from './Content';
import { NotificationDrawerHeader } from './Header';

type NotificationDrawerProps = {
  opened: boolean;
  onClose: () => void;
  formId: number;
  store: FormListPageStore;
  activeTab: string;
  onTabChange: (tab: string) => void;
};

const NotificationDrawer: React.FC<NotificationDrawerProps> = ({
  opened,
  onClose,
  formId,
  store,
  activeTab,
  onTabChange,
}) => {
  const handleClose = React.useCallback(
    (e: React.MouseEvent | React.KeyboardEvent) => {
      e.stopPropagation();
      onClose();
    },
    [onClose]
  );

  return (
    <Drawer
      open={opened}
      onClose={handleClose}
      width={MODAL_SIZES.m}
      title={<NotificationDrawerHeader />}
      onClick={(e) => e.stopPropagation()}
    >
      <NotificationDrawerContent
        formId={formId}
        store={store}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
    </Drawer>
  );
};

export default observer(NotificationDrawer);
